import { useQuery } from 'react-query';

import { CountryCode } from '../../types/CountryCode';
import Api from '../api/api';

const getCountryCode = async (): Promise<CountryCode[]> => {
  const [response, bodyOrError] = await Api.get('users/country-codes');

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

/**
 * React Query hook to fetch and cache supported country codes.
 * @param options Optional React Query configuration.
 * @returns React Query result containing the country codes data.
 */
export const useGetCountryCodes = () => useQuery(['getCountryCode'], () => getCountryCode(), {});
